export default "__VITE_ASSET__DPrOztVM__"